import React, { useEffect, useState } from "react";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { Table } from "antd";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import "./styles/personalfamilyInformation.css";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DropdownWithButton from "../../components/Dropdown/DropdownWithButton";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useFetchItems from "../../hooks/useFetchItems";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import { getAllColumns } from "./columnsData";
import useDeleteItem from "../../hooks/useDeleteItem";
import useModalHandlers from "../../hooks/useModalHandler";
import useFetchContacts from "../../hooks/useFetchContacts";
import useChangeHandler from "../../hooks/useChangeHandler";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Household Members",
  "Primary Doctor Contact Information",
  "Pediatrician Contact",
  "Personal and Family Information",
  "School Name",
  "Pet Information",
  "Workplace/Employer Name",
  "Out-of-State Contact Person Personal and Family Information",
];
export default function PersonalFamilyInformation() {
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attributesData, setAttributesData] = useState(null);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(moduleNames, setLoading);

  console.log("disaster Attribute Data",disasterAttributeData);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { contactList } = useFetchContacts(setLoading);

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  console.log("PersonalFamilyAtributes", attributes);

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const history = useHistory();

  const tableDataObj = {
    "Personal and Family Information":
      tableData.personalAndFamilyInformationData,
    "School Name": tableData.schoolNameData,
    "Pet Information": tableData.petInformationData,
    "Workplace/Employer Name": tableData.workplaceEmployerNameData,
    "Pediatrician Contact": tableData.pediatricianContactData,
    "Household Members": tableData.householdMembersData,
    "Primary Doctor Contact Information":
      tableData.primaryDoctorContactInformationData,
    "Out-of-State Contact Person Personal and Family Information":
      tableData.outofStateContactPersonPersonalAndFamilyInformationData,
  };

  console.log("tableData", tableData);

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  console.log("formdataaa", formData);
  const handleFormDataUpdate = (formData) => {
    const Payload = {
      Name: formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      "Date of Birth": formData && formData.birthday,
      Location: [
        formData && formData.homeStreet,
        formData && formData.secondHomeStreet,
        formData && formData.homeCity,
        formData && formData.homeState,
        formData && formData.homeZip,
      ]
        .filter(function (item) {
          return item != null && item !== "";
        })
        .join(", "),
    };

    console.log("Payload to update formData:", Payload);

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };

  const collapseableTables = [
    { title: "Household Members", key: 1 },
    { title: "Primary Doctor Contact Information", key: 2 },
    { title: "Pediatrician Contact", key: 3 },
    { title: "Pet Information", key: 4 },
  ];
  const workplaceTables = [
    { title: "School Name", key: 5 },
    { title: "Workplace/Employer Name", key: 6 },
    {
      displayTitle: "Out-of-State Contact Person",
      backendTitle:
        "Out-of-State Contact Person Personal and Family Information",
      key: 7,
    },
  ];
  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  // const handleItemsInfoSelect = (name, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  console.log("Module Name222", moduleName, tableData);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const updatedContactList = userData
    ? [
        {
          value: userData.id,
          label: userData.name,
          id: userData.id,
          clientId: userData.clientId,
          prefix: null,
          phoneNumber:userData.countryCode + userData.phoneNumber,
          name: userData.name,
        },
        ...contactList,
      ]
    : contactList;

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Personal & Family Information</h2>
        <ToolTipCreator name={"Disaster_Personal_Family_Information"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() =>
            table.title === "Pet Information"
              ? showModal(table.title)
              : AddContact()
          }
          options={updatedContactList}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          handleFormDataUpdate={handleFormDataUpdate}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>

      <div className="child-title-container">
        <h2 className="child-title">Veterinary Records</h2>
      </div>
      <DropdownWithButton
        placeholder={""}
        options={contactList}
        formData={formData}
        setFormData={setFormData}
        createAttributes={createAttributes}
        onClick={AddDocument}
      />

      {workplaceTables.map((table) => {
        const displayTitle = table.displayTitle || table.title;
        const backendTitle = table.backendTitle || table.title;

        return (
          <CollapseableTable
            title={displayTitle}
            key={table.key}
            setFormData={setFormData}
            formData={formData}
            setModuleName={() => setModuleName(backendTitle)}
            handleFormDataUpdate={handleFormDataUpdate}
            createAttributes={createAttributes}
            options={updatedContactList}
            onClick={() => showModal(backendTitle)}
            showDropDown={table.key === 7}
          >
            <Table
              columns={AllColumnsData[backendTitle]}
              dataSource={tableDataObj[backendTitle]}
            />
            <NewLoader isLoading={loading} />
          </CollapseableTable>
        );
      })}
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData && disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      <NewLoader isLoading={loading} />
    </div>
  );
}
